import { useMutation } from "@tanstack/react-query";
import { AuthApi } from "../../api/common/apiIndex";
import { toast } from "react-toastify";

export default function EmailVerifyBanner({ emailVerified, email }) {
  const resend = useMutation({
    mutationFn: () => AuthApi.resendVerification({ email }),
    onSuccess: (r) => toast.success(r?.message || "Verification email sent."),
    onError: (e) => {
      const msg = e?.response?.data || "Unable to send verification email right now.";
      toast.error(msg);
    },
  });

  if (emailVerified) return null;

  return (
    <div className="alert alert-warning d-flex align-items-center gap-2 mb-3" role="alert">
      <span>Confirm your email to secure your account and unlock all features.</span>
      <button
        className="btn btn-sm btn-primary ms-auto"
        onClick={() => resend.mutate()}
        disabled={resend.isPending}
      >
        {resend.isPending ? "Sending..." : "Resend verification email"}
      </button>
    </div>
  );
}
